import axios from 'axios';
import { getHostname } from './server/server'

const hostname = getHostname();
const path = '/v2/customSql';

async function getAvailableSqlQueries() {
    const res = await axios.get(`${hostname}${path}/all`);
    return res.data;
}

async function getCustomSqlData(queryId) {
    console.log('Fetching custom SQL data for queryId:', queryId);
    const res = await axios.get(`${hostname}${path}/data/?queryId=${queryId}`);
    return res.data;
}

async function getAllCustomSqlData() {
    const res = await axios.get(`${hostname}${path}/all-data`);
    return res.data;
}

async function testCustomSqlQuery(query) {
    const res = await axios.post(`${hostname}${path}/test`, {query});
    return res.data;
}

async function saveCustomSqlQuery(query) {
    const res = await axios.post(`${hostname}${path}/`, {query});
    return res.data;
}

async function updateCustomSqlQuery(query) {
    const res = await axios.put(`${hostname}${path}/`, {query});
    return res.data;
}

async function deleteCustomSqlQuery(queryId) {
    const res = await axios.delete(`${hostname}${path}/${queryId}`);
    return res.data;
}

async function fetchTableStructure() {
    const res = await axios.get(`${hostname}${path}/tableStructure`);
    return res.data;
}

export {
    getAllCustomSqlData,
    testCustomSqlQuery,
    saveCustomSqlQuery,
    updateCustomSqlQuery,
    deleteCustomSqlQuery,
    fetchTableStructure,
    getAvailableSqlQueries,
    getCustomSqlData
}